import { IgTypography } from "@intelligems/ig-theme/IgTypography";
import { useTheme } from "@mui/material";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";

import { useSelector } from "@src/store";
import { ExperienceBuilderAiSelector } from "@src/store/slices/experienceBuilder/ai";
import { VivIdeasSelector } from "@src/store/slices/experienceBuilder/ideas";

import { IdeaLibraryItem } from "./IdeaLibraryItem";
import { IdeaLibrarySearch } from "./IdeaLibrarySearch";

/** Search box above the filtered ideas, filling the width beside the sidebar. */
export const IdeaLibraryResults = () => {
  const theme = useTheme();
  const query = useSelector(VivIdeasSelector.getQuery);
  const ideas = useSelector(VivIdeasSelector.getFilteredIdeas);
  // Sending is a no-op mid-turn (see `sendIdea`) — don't offer dead clicks.
  const busy = useSelector(ExperienceBuilderAiSelector.getIsAiBusy);

  return (
    <Stack sx={{ flex: 1, minWidth: 0, minHeight: 0 }}>
      <IdeaLibrarySearch />
      {ideas.length === 0 ? (
        <Stack
          alignItems="center"
          justifyContent="center"
          spacing={0.5}
          sx={{ flex: 1, textAlign: "center", px: 3 }}
        >
          <IgTypography fontWeight={600}>
            No ideas match {query ? `"${query}"` : "your filter"}
          </IgTypography>
          <IgTypography variant="body2" color={theme.palette.secondary.main}>
            Try a different search or category
          </IgTypography>
        </Stack>
      ) : (
        <Stack
          divider={<Divider sx={{ mx: 4 }} />}
          sx={{ overflowY: "auto", minHeight: 0 }}
        >
          {ideas.map((idea) => (
            <IdeaLibraryItem
              key={idea.id}
              idea={idea}
              disabled={busy}
              showCategory={Boolean(query)}
            />
          ))}
        </Stack>
      )}
    </Stack>
  );
};
